import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { IonVirtualScroll } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MessageBoardService } from 'src/app/api/utils/message-board/message-board.service';
import { MessageBoardItem, MESSAGE_BOARD_ITEM_TYPE } from 'src/app/models/utils/message-board.model';

import each from 'lodash/each';

@Component({
  selector: 'hub-message-board',
  templateUrl: './message-board.component.html',
  styleUrls: ['./message-board.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageBoardComponent implements OnInit {
  /**
   * The ion virtual scroll component
   */
  @ViewChild('messageBoardVirtualScroll', { read: IonVirtualScroll, static: true })
  messageBoardVirtualScroll: IonVirtualScroll;

  /** The list of message board items to display */
  public items: MessageBoardItem[] = [];

  /** The display state of the component */
  public state: 'show' | 'hide' = 'hide';

  /** Subscription to listen to any print retry attemp */
  private _printRetryListener: Subscription;

  /** Subscription to listen to display state changes */
  private _showHideListener: Subscription;

  /** Subscription to listen to toggle the display state */
  private _toggleVisiblityListener: Subscription;

  /** Subscription to listen to any message board item changes */
  private _messageUpdate: Subscription;

  constructor(
    public el: ElementRef,
    public messageBoardService: MessageBoardService,
    public render: Renderer2,
    public changeRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this._printRetryListener = this.messageBoardService.printRetryChanged.subscribe(() => {
      // update the View
      this.changeRef.detectChanges();
    });

    this._showHideListener = this.messageBoardService.showHideMessageBoard.subscribe((state: boolean) => {
      this.updateMessageBoardState(state ? 'show' : 'hide');
    });

    this._toggleVisiblityListener = this.messageBoardService.toggleMessageBoard.subscribe(() => {
      this.updateMessageBoardState(this.state == 'show' ? 'hide' : 'show');
    });

    this._messageUpdate = this.messageBoardService.messageBoardUpdate.pipe(debounceTime(300)).subscribe(() => {
      this.items = [...this.messageBoardService.Message_board_items];

      if (this.items && this.items.length > 0) {
        // sort by added item
        this.items = this.items.sort((a: MessageBoardItem, b: MessageBoardItem) => {
          return a.added_time - b.added_time;
        });
      } else {
        // hide board if empty
        this.messageBoardService.hide();
      }

      // update the View
      this.changeRef.detectChanges();
    });
  }

  itemTrackByFn = (index, item: MessageBoardItem) => {
    // ideal scenario
    return item.ID + '' + item.added_time;
  };

  /** Update the display state of the component */
  updateMessageBoardState(state: 'show' | 'hide') {
    this.state = state;

    if (this.state == 'show') {
      this.render.addClass(this.el.nativeElement, 'show-message-board');
    } else {
      this.render.removeClass(this.el.nativeElement, 'show-message-board');
    }
  }

  // this is to prevent flickering of items in virtual scroll
  itemHeightFn(item, index) {
    return 110;
  }

  ngOnDestroy() {
    if (this._showHideListener) this._showHideListener.unsubscribe();
    if (this._toggleVisiblityListener) this._toggleVisiblityListener.unsubscribe();
    if (this._messageUpdate) this._messageUpdate.unsubscribe();
    if (this._printRetryListener) this._printRetryListener.unsubscribe();
  }
}
